module.exports = __webpack_public_path__ + "static/img/viral.3ed5f74c.jpg";